'use client';

import { useMemo, useState } from 'react';

import { UserToggles } from '@ravago/shared/page-data/models/config';
import { NormalizedUnitOfMeasure } from '@ravago/shared/page-data/models/contentful-mapped';

import { resolveRequestForQuotationUom, RfqUomPreference } from '../utils/rfq-uom-utils';

interface Props {
   channelUOMs: NormalizedUnitOfMeasure[];
   userToggles: UserToggles;
   preferences?: RfqUomPreference[];
}

export const useRequestForQuotationUom = ({ channelUOMs, userToggles, preferences }: Props) => {
   const [userSelectedUomId, setUserSelectedUomId] = useState<string | undefined>();

   const resolved = useMemo(
      () => resolveRequestForQuotationUom({ channelUOMs, userToggles, preferences, userSelectedUomId }),
      [channelUOMs, preferences, userSelectedUomId, userToggles]
   );

   return {
      ...resolved,
      onUomChange: setUserSelectedUomId
   };
};
